// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2_5SD","footer":"ModalError_footer__cI58w"};